import React from 'react'
import Tilt from 'react-tilt'


import '../assets/css/timeline.css'

function Timeline(props) {
    const timeline = props.timeline
    // console.log(Object.entries(timeline).map( ([key, value]) => `My key is ${key} and my value is ${value}` ))
  return (
      <div class="mt-3">
          <h1>Timeline</h1>
         <div className="wrapper">
            <section className="block">
                <div className="each-year">
                <div className="title"></div>
                    {
                        Object.entries(timeline).map(([key,value]) => {
                            return (
                           
                                <div className="event-description each-event">
                                   <p> {key} </p>
                                   <p> {value} </p>
                                </div>
                           
                            )
                        })
                    }
                </div>
            </section>
        </div>
        <div className='timeline-mob'>
                  {
                      Object.entries(timeline).map(([key,value]) => {
                        return (
                            <p style={{color : 'white' , textAlign : 'center', fontSize : '0.5 rem'} }> {key} : {value} </p>
                        )
                    })
                  }  
        </div>
      </div>
   
  )
}

export default Timeline